import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

function Spinner({
  className,
  size = "default",
  id,
  ...props
}: React.ComponentProps<"svg"> & {
  size?: "default" | "sm";
  id?: string;
}) {
  return (
    <Loader2
      id={id}
      role="status"
      aria-label="Loading"
      className={cn(
        "animate-spin text-current",
        size === "sm" ? "size-4" : "size-5",
        className
      )}
      {...props}
    />
  );
}


export { Spinner };
